 <div *ngIf="setupCompleted" class="marT20">
    <div class="card setup-school-card">                          
        <div class="content text-center">
          <div class="school-setup-icon">
            <img src="assets/images/proj_mgmt_ico.png" alt="">
          </div>                            
          <div class="title module-title dashboard-item-title marT15">
            {{'School set-up is complete' | translate }}
          </div>
          <div class="module-desc dashboard-item-subtitle marT10 padLR15">{{'Your school details can be viewed' | translate }}</div>
          <div class="school-setup-button marT30">
            <a data-toggle="modal" [routerLink]="['/projectmanagement',this.project_id, this.school_id,'view']" class="btn primary marT20">{{'Go to School Management' | translate }}</a>
          </div>
          

        </div>
      </div>  
  </div> 
  <div *ngIf="!setupCompleted">
  <div>
      <label class="form-title">4. {{'Assign teachers' | translate }}</label>
      <label class="label-light">{{schoolDetails.name}}</label>
  </div>
  <div class="marT20">
    <label *ngIf="!nextBtnClicked && !setupCompleted" class="labeltxt">{{'Finally, assign teachers to each class subject. When you are done, select Review.' | translate }}</label>
    <label *ngIf="nextBtnClicked" class="labeltxt">{{'Is this correct' | translate }}</label>
  </div>
  </div> 
  <div *ngIf="!setupCompleted"> 
    <div>
      <form [formGroup]="myForm">
        <div class="row marT20 marB5 flexStart" >
         
            <div class="md-3"><label class="label-light-opa ">{{'School grade' | translate }}</label></div>
            <div class="md-2"><label class="label-light-opa ">{{'Classes' | translate }}</label></div>
            <div class="md-3"><label class="label-light-opa ">{{'Subjects' | translate }}</label></div>
            <div class="md-4"><label class="label-light-opa ">{{'Teachers' | translate }}</label></div>
          
        </div>
        <div class="bot-line"></div>
        <div *ngIf="!nextBtnClicked" formArrayName="subjectteacher">
          <div class="assignteacherList">
            <div *ngFor="let grade of this.gradeList; let i = index">
              <ng-container *ngIf="i==(gradeCount-1)">
                <div class="row marB10">
                  <div class="md-3">
                      <label class="labeltxt marT5 " style="margin-bottom: 5px;" >{{grade?.name}}</label>
                  </div>
                  <div class="md-2" >
                    <label class="labeltxt marT5" >
                      <ng-container *ngFor="let classes of grade.classes">
                        <ul style="list-style: none;margin-bottom: 8px;" [ngClass]="textDir=='rtl'?'padR0':'padL0'">
                          <li *ngFor="let subjects of grade.subjects" class="classList">
                            <a style="cursor: default; padding-bottom: 4px;">{{classes.name}}</a>
                          </li>
                        </ul>
                      </ng-container>
                    </label>        
                  </div>
                  <div class="md-3">
                    <label class="labeltxt marT5" >
                      <ng-container *ngFor="let classes of grade.classes">
                        <ul style="list-style: none;margin-bottom: 8px;" [dir]="textDir">
                          <li *ngFor="let subjects of grade.subjects" class="subjectList">
                            <a style="color:#333;cursor: default; padding-bottom: 9px;">{{subjects.name}}</a>
                          </li>
                        </ul>
                      </ng-container>
                    </label> 
                  </div>
                  <div class="md-4" >
                    <div *ngIf="!nextBtnClicked" [ngClass]="!nextBtnClicked?'marT05':''">
                      <ng-container *ngFor="let classes of grade.classes; let j = index">  
                        <ng-container *ngFor="let ctrl of myForm.controls.subjectteacher.controls let l = index">  
                          <ul class="teacherList"  [ngClass]="textDir=='rtl'?'padR0':'padL0'">  
                            <ng-container *ngFor="let subjects of grade.subjects;"> 
                              <li *ngIf="myForm?.controls?.subjectteacher.controls[l].get('subject').value?._id === subjects?._id && classes._id === myForm?.controls?.subjectteacher.controls[l].get('class').value" class="t-dropdwn-wid" [formGroupName]="l" >
                                <div [ngClass]="textDir"><ngx-select-dropdown formControlName="teacher" [multiple]="false" [options]="mTeachers[l]" [config]="teacherSelectConfig" ></ngx-select-dropdown></div>
                              </li>
                            </ng-container>
                          </ul>
                        </ng-container>
                      </ng-container>
                    </div>             
                  </div>
                </div>
              </ng-container>
              <div></div>
               
            </div>
          </div>
        </div>  
        <div *ngIf="nextBtnClicked" formArrayName="subjectteacher">
          <div class="review-content padT15">
            <div *ngFor="let grade of this.gradeList; let i = index">
              <ng-container>
                <div class="row marB10">
                  <div class="md-3">
                      <label class="labeltxt marT5" >{{grade?.name}}</label>
                  </div>
                  <div class="md-2" >
                    <label class="marT5" >
                      <ng-container *ngFor="let classes of grade.classes">
                        <ul class="list" [ngClass]="textDir=='rtl'?'padR0':'padL0'">
                          <li *ngFor="let subjects of grade.subjects" style="height: 30px;">
                            <label class="labeltxt"><a style="color:#333;cursor: default;">{{classes.name}}</a></label>
                          </li>
                        </ul>
                      </ng-container>
                    </label>        
                  </div>
                  <div class="md-3">
                    <label class="marT5" >
                      <ng-container *ngFor="let classes of grade.classes">
                        <ul class="list" [ngClass]="textDir=='rtl'?'padR0':'padL0'">
                          <li *ngFor="let subjects of grade.subjects" style="height: 30px;">
                            <label class="labeltxt"><a style="color:#333;cursor: default;">{{subjects.name}}</a></label>
                          </li>
                        </ul>
                      </ng-container>
                    </label> 
                  </div>
                  <div class="md-4" >
                    <div *ngIf="nextBtnClicked" >
                      <ng-container *ngFor="let classes of grade.classes; let j = index;">  
                        <ng-container *ngFor="let ctrl of myForm.controls.subjectteacher.controls let l = index">  
                          <ul class="marT5" class="list" [ngClass]="textDir=='rtl'?'padR0':'padL0'">   
                            <ng-container *ngFor="let subjects of grade.subjects;"> 
                              <li *ngIf="myForm?.controls?.subjectteacher.controls[l].get('subject').value?._id === subjects?._id && classes._id === myForm?.controls?.subjectteacher.controls[l].get('class').value" style="height: 30px;" [formGroupName]="l">
                               <label class="labeltxt"> {{myForm?.controls?.subjectteacher.controls[l].get('teacher').value?.name}}</label>
                              </li>
                            </ng-container>
                          </ul>
                        </ng-container>
                      </ng-container>
                    </div>             
                  </div>
                </div>
              </ng-container>
              <div></div>
              
            </div>
          </div>    
        </div>        
      </form>
    </div>
  </div> 
  
  
  <div class="h-line" *ngIf="!setupCompleted"></div>
  <div class="spaceBtwn marT20" >
    <div *ngIf="!setupCompleted">   
      <a (click)="callCancelSetup()" class="btn btn-cancel" >{{'Cancel' | translate}}</a>
    </div>
    <!-- <div *ngIf="!nextBtnClicked">
      <ul class="pagination"  *ngIf="!setupCompleted" style="padding-left: 0px;">
        <li *ngFor="let page of this.gradeList; let i = index">
          <a href="javascript:void(0)" style="cursor: default;border: none;background: none;">
          <ng-container  *ngIf="i!=(gradeCount-1)"><img src="assets/images/grey_dot.png" width="10" height="10"></ng-container> 
          <ng-container *ngIf="i==(gradeCount-1)"><img src="assets/images/blue_dot.png" width="10" height="10"></ng-container>
          </a>
        </li>
      </ul>
    </div> -->
    <div *ngIf="!setupCompleted" style="display: flex;justify-content: flex-end;">
      
      <div ><button type="button" (click)='prevGrade()' *ngIf="!nextBtnClicked && (gradeCount >1 && gradeCount <= (this.gradeList.length+1))" class="btn btn-back " [ngClass]="textDir=='rtl'?'marL10':'marR10'"><i class="icon icon-arrow-left padR5"></i> {{backText | translate}}</button></div>
      <div ><button type="button" (click)='nextGrade()' *ngIf="!nextBtnClicked && (gradeCount >0 && gradeCount <= (this.gradeList.length+1))" class="btn btn-next primary btn-wid">{{btnText | translate}} <i class="icon icon-arrow-right padL5"></i></button></div>
      <div ><button type="button" (click)='prevGrade()' *ngIf="nextBtnClicked && (gradeCount >1 && gradeCount <= (this.gradeList.length+1))" class="btn btn-back " [ngClass]="textDir=='rtl'?'marL10':'marR10'"><i class="icon icon-arrow-left padR5"></i> {{backText | translate}}</button></div>
      <div ><button type="button" (click)='nextGrade()' *ngIf="nextBtnClicked && (gradeCount >0 && gradeCount <= (this.gradeList.length+1))" class="btn btn-next primary btn-wid">{{btnText | translate}} <i class="icon icon-arrow-right padL5"></i></button></div>

   
    </div>
   
  </div>
  
  
  <div class="modal in smallmodal" id="skipModal1" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby="basicModal" aria-hidden="false" style="display: none; text-align: center">
    <div class="modal-dialog modal-dialog-centered skipModalWidth"  role="document" >
        <div class="modal-content">
            <div class="modal-header">    
                <div class="modal-title" id="myModalLabel" style="text-align:left;font-size:18px;color:#4a4a48;vertical-align: top;margin-left: 10px;margin-top: 10px;">
                    <span class="glyphicon confirm" > <img style="height: 26px;width: 26px;margin-top: -15px;" src="assets/images/warning2.png" alt=""></span> &nbsp; {{this.titleMessage}}
                </div>
            </div>
            <div class="modal-body" style="margin-left: 50px;padding:0px 15px;padding-bottom: 20px;">
                <div class="modal-text">
  <!--                 <p class="grey-text" *ngIf="currentSteps!=3 && this.detailMessage1" style="font-size: 12px;text-align: left;color: #808080;" [innerHTML]="detailMessage1"></p>
  -->                <div >
                    <p class="grey-text" style="text-align: left;color: #666666;">{{'Steps 1 - 3 are saved. You will skip this step:' | translate}}<br></p>
                    <div class="grey-text" style="text-align: left;">     
                            <ul style="padding-left:0px;text-align: left;list-style: none;">
                               
                                <li >
                                    4) {{'Assign Teachers to Classes' | translate}}
                                </li>
                            </ul>
                    </div>  
                    <p class="grey-text" style="line-height:15px;text-align: left;">{{'You can complete this step in the School Management module.' | translate}}</p>
  
            </div>
                <p *ngIf="this.detailMessage2" style="font-size: 12px;text-align: left;color: #000000;" [innerHTML]="detailMessage2"></p>
                </div>
            </div>
            <div class="modal-footer" style="height:40px;">
                <p align="center">
                     <a class="btn-sm btn-grey" (click)="cancelDelete();">&nbsp;&nbsp;{{'Cancel' | translate}}&nbsp;&nbsp;</a> 
                    <a class="btn btn-next" (click)="showSetupComplete()">&nbsp;&nbsp;{{'Ok' | translate}&nbsp;&nbsp;</a>
                </p>
            </div>
        </div>
    </div>
  </div>